import { render, staticRenderFns } from "./distributionStation-block-dist.vue?vue&type=template&id=24ab9889&scoped=true"
import script from "./distributionStation-block-dist.vue?vue&type=script&lang=js"
export * from "./distributionStation-block-dist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab9889",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24ab9889')) {
      api.createRecord('24ab9889', component.options)
    } else {
      api.reload('24ab9889', component.options)
    }
    module.hot.accept("./distributionStation-block-dist.vue?vue&type=template&id=24ab9889&scoped=true", function () {
      api.rerender('24ab9889', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/distributionStation-management/distributionStation-list/distributionStation-block-dist.vue"
export default component.exports